var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "root", staticClass: "copy-synopsis-select" }, [
    _c(
      "button",
      {
        staticClass: "trigger",
        attrs: {
          id: "contest-entry-copy-synopsis",
          type: "button",
          "aria-haspopup": "menu",
          "aria-expanded": _setup.isOpen,
          "aria-controls": "contest-entry-copy-synopsis-menu",
        },
        on: { click: _setup.toggle },
      },
      [
        _c("span", { staticClass: "trigger-label" }, [
          _vm._v(
            _vm._s(_setup.t("contestEntryForm.step2.copySynopsis.placeholder"))
          ),
        ]),
        _c(_setup.IconChevronDown, { staticClass: "trigger-chevron" }),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _setup.isOpen,
            expression: "isOpen",
          },
        ],
        staticClass: "menu",
        attrs: {
          id: "contest-entry-copy-synopsis-menu",
          role: "menu",
          "aria-label": _setup.t(
            "contestEntryForm.step2.copySynopsis.placeholder"
          ),
        },
      },
      _vm._l(_setup.options, function (option) {
        return _c(
          "button",
          {
            key: option.value,
            staticClass: "menu-item",
            attrs: { type: "button", role: "menuitem" },
            on: {
              click: function ($event) {
                return _setup.onSelect(option.value)
              },
            },
          },
          [_vm._v(" " + _vm._s(option.label) + " ")]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }